
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'DefaultLayout',
})
export default class extends Vue {}
